import us from "@/assets/flags/us.svg?url";
import gb from "@/assets/flags/gb.svg?url";
import de from "@/assets/flags/de.svg?url";
import es from "@/assets/flags/es.svg?url";
import gr from "@/assets/flags/gr.svg?url";
import au from "@/assets/flags/au.svg?url";
import sg from "@/assets/flags/sg.svg?url";
import ae from "@/assets/flags/ae.svg?url";
import vn from "@/assets/flags/vn.svg?url";
import nl from "@/assets/flags/nl.svg?url";
import it from "@/assets/flags/it.svg?url";
import fr from "@/assets/flags/fr.svg?url";

const FLAGS: Record<string, string> = {
  US: us, GB: gb, DE: de, ES: es, GR: gr,
  AU: au, SG: sg, AE: ae, VN: vn, NL: nl,
  IT: it, FR: fr,
};

export function Flag({ code, fallback, className = "h-4 w-4" }: { code: string; fallback?: string; className?: string }) {
  const src = FLAGS[code];
  if (!src) return <span className={className} aria-hidden>{fallback}</span>;
  return (
    <span className={`inline-block overflow-hidden rounded-full ring-1 ring-foreground/10 ${className}`}>
      <img src={src} alt="" className="h-full w-full object-cover" loading="lazy" />
    </span>
  );
}
